import { Component, ComponentFactoryResolver, OnInit, Type, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { RegistrationConstants } from './registration.constants';
import { ApiService, CacheService, MiscConfig, RegistrationModel, RegistrationStep } from 'angular-lib';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'ez-registration',
    template: require('./registration.component.html'),
    styles: [require('./registration.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class RegistrationComponent implements OnInit {
    public registrationDatas: RegistrationModel;
    public miscConfig: MiscConfig;
    public currentStepIndex: number = 0;

    @ViewChild('stepContainer', {read: ViewContainerRef}) private stepContainer: ViewContainerRef;

    constructor(
        private apiService: ApiService,
        private constants: RegistrationConstants,
        private resolver: ComponentFactoryResolver,
        private router: Router
    ) {
    }

    public ngOnInit() {
        this.apiService.miscConfig().subscribe((data) => {
            this.miscConfig = data;
            this.startStep();
        });
    }

    public loadStep(component: Type<RegistrationStep>) {
        this.stepContainer.clear();
        let factory = this.resolver.resolveComponentFactory(component);

        let ref = this.stepContainer.createComponent(factory);
        ref.instance.miscConfig = this.miscConfig;
        ref.instance.registrationModel = this.registrationDatas;
        ref.instance.nextStep.subscribe(event => this.nextStep(event));
        ref.instance.backStep.subscribe(event => this.backStep(event));
        // todo memory leak ! must unsubscribe
    }

    public startStep() {
        let step: string;

        if (!this.registrationDatas) {
            this.registrationDatas = RegistrationModel.initFromLocalStorage()
                || new RegistrationModel({
                    channelId: environment.channelId
                });
        }

        if (!this.registrationDatas.currentStep) {
            this.registrationDatas.channelId = environment.channelId;

            this.registrationDatas.firstStep = step = 'gender';
        } else {
            let steps = this.constants.steps;
            let index = steps.indexOf(this.registrationDatas.currentStep);
            if (index !== -1) {
                step = steps[index];
            }

            this.currentStepIndex = index;
        }

        this.registrationDatas.currentStep = step;
        this.loadStep(this.constants.mapping[step]);
    }

    public backStep(_?: any) {
        let steps = this.constants.steps;
        let index = steps.indexOf(this.registrationDatas.currentStep);
        if (index > -1) {
            let step = steps[index - 1];
            this.registrationDatas.currentStep = steps[index - 1];
            this.registrationDatas.save();
            this.loadStep(this.constants.mapping[step]);
        }

        this.currentStepIndex = index - 1;
    }

    public nextStep(_?: any) {
        let steps = this.constants.steps;
        let index = steps.indexOf(this.registrationDatas.currentStep);
        let step = steps[index + 1];

        this.currentStepIndex = index + 1;

        if (step) {
            this.registrationDatas.currentStep = step;
            this.registrationDatas.save();
            this.loadStep(this.constants.mapping[step]);
        } else {
            this.registrationDatas.clear();
            CacheService.remove(CacheService.LOGGED_USER);
            this.router.navigate(['/member/home']);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/registration.component.ts